var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenderoutlineSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "#080404",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 69.7 17.4 C 63.2 19.2 57.1 23.8 53.5 29.5 L 50.5 34.3 L 50.2 60.3 C 49.9 84.9 50 86.2 51.7 85.6 C 52.7 85.2 56.5 84.6 60.2 84.3 L 66.9 83.7 L 67.2 61.3 L 67.5 38.8 L 70.3 36.4 C 76.2 31.3 76.8 31.6 121.6 59.1 C 144.1 72.9 163.3 85.1 164.3 86.2 C 166.5 88.8 166.5 94.2 164.3 96.9 C 163.3 98.1 153.5 104.6 142.5 111.4 C 126.9 121 122.6 124.1 122.7 125.6 C 124.1 136.5 124.9 141.2 125.3 141.6 C 125.9 142.2 168.8 116 174.2 111.8 C 178.3 108.6 182.6 100.6 183.6 94.4 C 184.5 88.1 181.7 79.7 176.9 74.5 C 174.1 71.5 160.3 62.4 132.2 45.1 C 109.8 31.4 89.9 19.4 87.9 18.6 C 82.5 16.4 75.1 15.9 69.7 17.4 M 53.5 101.3 C 47.5 103.3 42 106.4 37.6 110.2 L 33.7 113.6 L 30.9 110.8 C 27.6 107.4 23.4 107.1 19.7 110 C 15.7 113.2 15.7 115.8 19.6 130.2 C 24.7 148.7 25.4 150 32 150 C 35.6 150 58.9 137 61.4 133.6 C 64.3 129.8 62.7 124.1 58.3 122 C 56.5 121.2 55 120.2 55 119.8 C 55 119.4 56.7 118.6 58.8 118.1 C 75 113.5 91 125.5 91 142 C 91 149 88.5 154.4 83.1 159.3 C 78.2 163.8 75.6 164.9 67.6 166 C 64.4 166.5 61 167.6 60 168.5 C 55.6 172.5 56.9 180.2 62.4 182.9 C 64.8 184 66.6 184 72.3 183.1 C 81.9 181.5 89.5 177.7 96.1 171.1 C 116.8 150.3 111 117 84.4 103.9 C 78.3 100.9 76.7 100.5 67.6 100.3 C 61.2 100.1 56 100.5 53.5 101.3",
    stroke: "none",
    fill: "#040404",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenderoutlineSvg);
export default __webpack_public_path__ + "static/media/renderoutline-svg.8942aeba.svg";
export { ForwardRef as ReactComponent };